module.exports = __webpack_public_path__ + "static/media/04B.38dd8e61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robots/04B.png
// module id = 261
// module chunks = 0